<template>
  <BaseModal
    v-if="managedPage.hasOwnProperty('uuid')"
    :show="show"
    @close="close"
  >
    <div>
      <h3
        class="font-extrabold"
        v-text="'Delete Managed Page'"
      />
    </div>
    <div
      v-if="managedPage.attributes.title"
      class="modal-body"
    >
      <p>
        Are you sure you want to delete
        <span
          class="italic"
          v-text="managedPage.attributes.title"
        />
        ?
      </p>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-blue"
        @click="destroy"
        v-text="'Delete'"
      />
      <a
        href="#"
        class="mx-4 px-2"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'

export default {
  name: 'DeleteManagedPageModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    managedPage: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    ...mapActions({
      deleteManagedPage: 'managedPageDeleteManagedPage',
    }),
    destroy() {
      this.deleteManagedPage(this.managedPage.uuid).then(() => {
        this.$emit('destroyed')

        this.close()
      }).catch(() => {
        this.close()
      })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
